 
import React from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const ErrorPage = () => {
    return (
        <Container className="py-5">
            <Row className="justify-content-center">
                <Col md={6}>
                    <Card className="text-center shadow">
                        <Card.Body className="py-5">
                            <div className="mb-4">
                                <i className="bi bi-exclamation-triangle" style={{ fontSize: '4rem', color: '#dc3545' }}></i>
                            </div>
                            <h3 className="mb-3">Oops! Something went wrong</h3>
                            <p className="text-muted mb-4">
                                The page you're looking for doesn't exist or there was an error processing your request.
                            </p>
                            <Button as={Link} to="/admin" variant="primary">
                                <i className="bi bi-house me-2"></i>
                                Go to Dashboard
                            </Button>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default ErrorPage;
